import { render, staticRenderFns } from "./CoursesWorld.vue?vue&type=template&id=9fd53cfe&scoped=true&"
import script from "./CoursesWorld.vue?vue&type=script&lang=js&"
export * from "./CoursesWorld.vue?vue&type=script&lang=js&"
import style0 from "./CoursesWorld.vue?vue&type=style&index=0&id=9fd53cfe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fd53cfe",
  null
  
)

export default component.exports